// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrderListWrapper_wrapper__3RVNF"};